import React from 'react';

import { ReactComponent } from '../../assets/svg/layers.svg';


export default () => <ReactComponent />;
